import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'
import {getBuild} from '../../../selectors'

import BuildQueueInfo from './BuildQueueInfo'
import type {OwnProps, StateProps} from './BuildQueueInfo.types'

const mapStateToProps = (state: State, {buildId}: OwnProps): StateProps => {
  const build = getBuild(state, buildId)
  return {
    queued: build?.state === 'queued',
    queuedDate: build?.queuedDate,
    startDate: build?.startDate,
    currentWaitReason: build?.waitReason,
  }
}

export default connect(mapStateToProps, {})(BuildQueueInfo)
